import { ClientDate } from '@/core/helpers';
import { IOperationalDay } from '@/dto/operationalPlanSummary/index';
import { OperationalDayName } from './OperationalDayName';

export class OperationalDay {

    public static fromDto(dto: IOperationalDay): OperationalDay {

        const name = OperationalDayName.fromDto(dto.name);
        const start = new ClientDate(dto.start);
        const finish = new ClientDate(dto.finish);

        const operDay = new OperationalDay(name, start, finish);

        return operDay;
    }

    public readonly name: OperationalDayName;
    public readonly start: ClientDate;
    public readonly finish: ClientDate;

    constructor(name: OperationalDayName, start: ClientDate, finish: ClientDate) {
        this.name = name;
        this.start = start;
        this.finish = finish;
    }

}
